import React, { FC } from "react";
import { HeroPrice, HeroPriceProps } from "./HeroPrice";
import { FeatureFlagsProvider } from "../../Context/FeatureFlagsContext";

export const HeroPriceProvider: FC<HeroPriceProps> = ({
  priceText,
  fontColor,
  optimizelyExperimentation,
}) => {
  return (
    <FeatureFlagsProvider sdkKey={optimizelyExperimentation.sdkKey}>
      <HeroPrice
        priceText={priceText}
        fontColor={fontColor}
        optimizelyExperimentation={optimizelyExperimentation}
      />
    </FeatureFlagsProvider>
  );
};
